import type {
	FinancialModuleConfig,
	UnitPayoutStatusValue,
} from "@/features/financialShared";

export const ChargesCategory = {
	COMMON_AREA: "Common Area Charges",
	UTILITIES: "Utilities",
	MANDATORY: "Mandatory Charges",
} as const;

export type ChargesCategoryValue =
	(typeof ChargesCategory)[keyof typeof ChargesCategory];

export interface ChargesUnitListItem {
	id: string;
	unitCode: string;
	ownerName: string;
	ownerEmail: string;
	amount: number;
	partialPayment: number | null;
	remainingLabel: string;
	isFullyPaid: boolean;
	paymentMethod: string;
	status: UnitPayoutStatusValue;
}

export interface ChargeLineItem {
	category: string;
	description: string;
	amount: number;
	tax: number;
	total: number;
}

export interface ChargesUnitDetail {
	id: string;
	propertyId: string;
	periodId: string;
	invoiceNumber: string;
	unitCode: string;
	ownerName: string;
	ownerInitials: string;
	ownerPhone: string;
	ownerEmail: string;
	unitDetail: string;
	status: UnitPayoutStatusValue;
	servicePeriodLabel: string;
	invoiceDate: string;
	paymentDate: string;
	lineItems: ChargeLineItem[];
	totalAmount: number;
}

export const CHARGES_MODULE_CONFIG: FinancialModuleConfig = {
	kind: "charges",
	label: "Charges Management",
	basePath: "/charges-management",
};
